export class GetAsset {
  constructor(assets) {
    try {
      Object.assign(this, {
        asset(key, defaults = '') {
          if (key) {
            return assets[key];
          }

          return defaults;
        },
      });
    } catch (e) {
      console.debug('error asset', e);
    }
  }
}
